module.exports = __webpack_public_path__ + "img/topics6.588305a8.png";